import { CustomFieldClassType } from 'shared'
import { ProjectCustomFieldsProvider } from '../../../../../../../components/CustomFields/ProjectCustomFieldsContext'
import { RFITrackerProvider } from './RFITrackerContext'
import RFITrackerTable from './components/RFITrackerTable'

const RFITracker: React.FC = () => (
  <ProjectCustomFieldsProvider
    classType={CustomFieldClassType.RequestForInformation}
  >
    <RFITrackerProvider>
      <RFITrackerTable />
    </RFITrackerProvider>
  </ProjectCustomFieldsProvider>
)

export default RFITracker
